import * as authConstants from '~/data/constants/auth';
import * as constants from '~/data/constants/imports';
import LoadingProgress from '~/data/utils/reducers/loading';
import Pagination from '~/data/utils/reducers/pagination';
import { fromJS } from 'immutable';

export const itemsPagination = new Pagination('imports');
export const listLoadingProgress = new LoadingProgress('importsList');
export const importUploadProgress = new LoadingProgress('importUpload');
export const importDownloadProgress = new LoadingProgress('importDownload');

const mergeData = (state, payload) =>
  state.withMutations((newState) => {
    const {
      entities: { imports },
    } = payload;
    newState.mergeIn(['entities'], fromJS(imports));
  });

const loadItems = (state, action) =>
  state.withMutations((newState) => {
    const { result, limit } = action.payload;
    const { count } = action;
    mergeData(newState, action.payload);
    itemsPagination.set(newState, count, limit, fromJS(result));
    listLoadingProgress.setLoaded(newState);
  });

const initialState = fromJS({
  entities: {},
});

export default (state = initialState, action) => {
  switch (action.type) {
    case constants.LIST_LOAD_START:
      return listLoadingProgress.setLoading(state);
    case constants.LIST_LOAD_SUCCESS:
      return loadItems(state, action);
    case constants.LIST_LOAD_FAILED:
      return listLoadingProgress.setLoadFailed(state);
    case constants.UPLOAD_START:
      return importUploadProgress.setLoading(state);
    case constants.UPLOAD_SUCCESS:
      return importUploadProgress.setLoaded(state);
    case constants.UPLOAD_FAILED:
      return importUploadProgress.setLoadFailed(state);

    case constants.DOWNLOAD_START:
      return importDownloadProgress.setLoading(state);
    case constants.DOWNLOAD_SUCCESS:
      return importDownloadProgress.setLoaded(state);
    case constants.DOWNLOAD_FAILED:
      return importDownloadProgress.setLoadFailed(state);
    case authConstants.SESSION_CLOSE:
    case constants.CLEAR:
      return initialState;
    default:
      return state;
  }
};
